export default __webpack_public_path__ + "static/media/makito-x4-logo.a2124671.svg";